import { combineReducers } from 'redux'
import drawer from './reducers/drawer'
import tabs from './reducers/tabs/tabs'

export default combineReducers({
  drawer,
  tabs,
})
